/* eslint-disable */
import React, { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const coverSlides = (cover) =>
  cover?.slides?.length ? cover.slides : cover?.image_url ? [{ url: cover.image_url, type: "image" }] : [];

// Cover background: images and videos in the CEO's order. Images stay `interval` ms, videos play to the end.
export const CoverMedia = ({ cover, interval = 3000 }) => {
  const slides = coverSlides(cover);
  const [idx, setIdx] = useState(0);
  const key = slides.map((s) => s.url).join("|");
  useEffect(() => { setIdx(0); }, [key]);
  const cur = slides[idx] || slides[0];
  const next = () => setIdx((i) => (i + 1) % slides.length);
  useEffect(() => {
    if (slides.length < 2) return;
    const t = setTimeout(next, cur?.type === "video" ? 120000 : interval);
    return () => clearTimeout(t);
  }, [idx, key, interval]);
  if (!slides.length) return null;
  return (
    <div className="absolute inset-0" data-testid="cover-slideshow">
      {slides.map((s, i) => s.type === "video" ? (
        i === idx ? <video key={s.url} src={abs(s.url)} autoPlay muted playsInline loop={slides.length === 1} onEnded={next} onError={() => slides.length > 1 && next()}
          className="absolute inset-0 w-full h-full object-cover" data-testid={i === 0 ? "cover-video" : `cover-slide-${i}`} /> : null
      ) : (
        <img key={s.url} src={abs(s.url)} alt="" className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700"
          style={{ opacity: i === idx ? 1 : 0 }} data-testid={`cover-slide-${i}`} />
      ))}
      {slides.length > 1 && (
        <div className="absolute bottom-3 right-4 z-10 flex gap-1.5" data-no-contrast-guard>
          {slides.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === idx ? "w-5 bg-amber-400" : "w-1.5 bg-white/60"}`} />
          ))}
        </div>
      )}
    </div>
  );
};
